import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
import { useRef, useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { HeroSpaceships } from './FloatingCharacters';

const YOUTUBE_VIDEO_ID = 'Jl2QLMOWe44';
const YOUTUBE_SHORTS_URL = 'https://www.youtube.com/shorts/Jl2QLMOWe44';
const SPOTIFY_TRACK_URL = 'https://open.spotify.com/track/16S6i3t313VeKNdhI1nWLj?si=6c75d3713a5a41eb';
const COSMIX_LOGO = "https://customer-assets.emergentagent.com/job_461f173b-2f7b-4524-a861-72bba2ed6414/artifacts/nskmtkd0_Cosmix%20Logo.png";
const SOUNDMOO_LOGO = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/wwsexp5e_SOUNDMOO%20OFFICIAL%20LOGO%20cropped.png";
const HOL_LOGO = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/dn9k5277_HOL%20Logo.png";
const STUDIO88_LOGO = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/yktgibry_PRODUCTIONS_300x.png";

// SVG Brand Logo Components — full color, recognizable
const NikeLogo = () => (
  <svg viewBox="0 0 100 35" className="h-8 md:h-10" fill="white">
    <path d="M9.5 29.7c-1.3 0-2.4-.4-3.1-1.3-.8-1-1-2.3-.6-3.8L13.3 1.9c.1-.4.5-.6.8-.4l1 .5c.3.2.4.5.3.8L8.1 25c-.2.7-.1 1.3.3 1.7.4.4 1 .6 1.7.5 1.4-.2 3.2-1.3 5.4-3.3L59.9.5c.3-.2.6-.1.8.1l.7.8c.2.3.2.6-.1.8L16.4 27.4c-3 2.5-5.1 3-6.9 2.3z"/>
  </svg>
);

const AppleLogo = () => (
  <svg viewBox="0 0 170 170" className="h-8 md:h-10" fill="white">
    <path d="M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.2-2.12-9.97-3.17-14.34-3.17-4.58 0-9.49 1.05-14.75 3.17-5.28 2.13-9.54 3.24-12.8 3.35-4.93.21-9.84-1.96-14.75-6.52-3.13-2.73-7.04-7.41-11.73-14.04-5.03-7.08-9.17-15.29-12.41-24.65-3.47-10.11-5.21-19.9-5.21-29.38 0-10.86 2.35-20.22 7.04-28.06 3.69-6.3 8.6-11.27 14.75-14.92 6.15-3.65 12.8-5.51 19.96-5.7 3.91 0 9.04 1.21 15.42 3.6 6.36 2.4 10.44 3.62 12.24 3.62 1.35 0 5.91-1.43 13.65-4.27 7.32-2.64 13.5-3.73 18.56-3.29 13.72 1.11 24.02 6.52 30.86 16.27-12.27 7.44-18.34 17.86-18.2 31.22.13 10.41 3.89 19.07 11.25 25.96 3.35 3.17 7.08 5.62 11.22 7.36-.9 2.61-1.85 5.11-2.86 7.51zM119.1 7.03c0 8.16-2.98 15.78-8.92 22.83-7.17 8.39-15.84 13.24-25.24 12.47a25.4 25.4 0 01-.19-3.09c0-7.83 3.41-16.21 9.47-23.06 3.03-3.45 6.88-6.32 11.55-8.62 4.66-2.27 9.07-3.52 13.22-3.75.12 1.08.17 2.16.11 3.22z"/>
  </svg>
);

const SpotifyLogo = () => (
  <svg viewBox="0 0 168 168" className="h-8 md:h-10" fill="#1DB954">
    <path d="M83.996.277C37.747.277.253 37.77.253 84.019c0 46.251 37.494 83.741 83.743 83.741 46.254 0 83.744-37.49 83.744-83.741C167.74 37.77 130.25.277 83.996.277zm38.404 120.78a5.217 5.217 0 01-7.18 1.73c-19.662-12.01-44.414-14.73-73.564-8.07a5.222 5.222 0 01-6.249-3.93 5.213 5.213 0 013.926-6.25c31.9-7.291 59.263-4.15 81.337 9.34 2.46 1.51 3.24 4.72 1.73 7.18zm10.25-22.805c-1.89 3.075-5.91 4.045-8.98 2.155-22.51-13.839-56.823-17.846-83.448-9.764-3.453 1.043-7.1-.903-8.148-4.35a6.538 6.538 0 014.354-8.143c30.413-9.228 68.222-4.758 94.072 11.127 3.07 1.89 4.04 5.91 2.15 8.976zm.88-23.744c-26.99-16.031-71.52-17.505-97.29-9.684-4.138 1.255-8.514-1.081-9.768-5.219a7.835 7.835 0 015.221-9.771c29.581-8.98 78.756-7.245 109.83 11.202a7.823 7.823 0 012.74 10.733 7.823 7.823 0 01-10.733 2.74z"/>
  </svg>
);

const UniversalLogo = () => (
  <div className="flex items-center gap-1.5">
    <svg viewBox="0 0 24 24" className="h-7 md:h-9" fill="white">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
    </svg>
    <span className="text-white font-bold text-xs md:text-sm whitespace-nowrap tracking-tight font-['Outfit']">UNIVERSAL MUSIC</span>
  </div>
);

const SonyLogo = () => (
  <div className="flex items-center">
    <span className="text-white font-black text-base md:text-xl tracking-tighter whitespace-nowrap" style={{ fontFamily: "'Outfit', sans-serif" }}>SONY</span>
    <span className="text-white/60 font-medium text-[10px] md:text-xs ml-1 whitespace-nowrap tracking-wide">MUSIC UK</span>
  </div>
);

const RocNationLogo = () => (
  <div className="flex items-center gap-1">
    <svg viewBox="0 0 24 24" className="h-5 md:h-6" fill="white">
      <path d="M12 2L1 12h3v9h6v-6h4v6h6v-9h3L12 2zm0 2.84L19 12h-1.5v9h-3v-6H9.5v6h-3v-9H5l7-7.16z"/>
    </svg>
    <span className="text-white font-black text-xs md:text-sm whitespace-nowrap tracking-widest font-['Outfit']">ROC NATION</span>
  </div>
);

const FootLockerLogo = () => (
  <div className="flex items-center">
    <span className="text-white font-black text-sm md:text-base whitespace-nowrap tracking-tight font-['Outfit']">FOOT LOCKER</span>
  </div>
);

const NIKE_LOGO = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/2spofe1u_nike-just-do-it-swoosh-logo-brand-nike-logo-free-png-image-0b97ead7f6104e90b9fea674d7594be1.png";
const FOOTLOCKER_LOGO = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/a9akd2l5_Foot%20Locker%20White%20logo.png";
const ROC_NATION_LOGO = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/o4cnf7u6_ROC_NATION__Logo.jpg";
const UNIVERSAL_LOGO = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/lictv17s_Universal_Music_Group_logo.svg.png";
const SONY_LOGO = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/zsueld28_Sony_Music_Entertainment_Logo_2023.svg.png";
const HOL_LOGO_NEW = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/zr9ief2p_HOL%20Logo.png";
const STUDIO88_LOGO_NEW = "https://customer-assets.emergentagent.com/job_02fb1ea7-05bc-49a3-acd9-1025e0802bad/artifacts/np5kz5ei_PRODUCTIONS_300x.png";

const partnerLogos = [
  { name: 'Universal Music', src: UNIVERSAL_LOGO },
  { name: 'Sony Music', src: SONY_LOGO },
  { name: 'Spotify', component: SpotifyLogo },
  { name: 'Apple', component: AppleLogo },
  { name: 'Roc Nation', src: ROC_NATION_LOGO },
  { name: 'Nike', src: NIKE_LOGO },
  { name: 'Foot Locker', src: FOOTLOCKER_LOGO },
  { name: 'House of L', src: HOL_LOGO_NEW },
  { name: 'Studio 88', src: STUDIO88_LOGO_NEW },
];

// Marquee component — TRUE seamless infinite loop, pure CSS
const LogoMarquee = () => {
  const LogoItem = ({ logo }) => (
    <div className="flex-shrink-0 flex items-center justify-center h-10 md:h-12 mx-6 md:mx-7">
      {logo.src ? (
        <img
          src={logo.src}
          alt={logo.name}
          className="h-8 md:h-10 max-w-[120px] md:max-w-[140px] object-contain"
        />
      ) : (
        <logo.component />
      )}
    </div>
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1, duration: 0.6 }}
      className="mt-5 md:mt-8 w-full max-w-2xl"
    >
      <p className="text-white/50 text-xs font-medium tracking-widest uppercase mb-5">Who we have worked with</p>
      <div className="marquee-container">
        <div className="marquee-track">
          {partnerLogos.map((logo, i) => <LogoItem key={`a-${i}`} logo={logo} />)}
          {partnerLogos.map((logo, i) => <LogoItem key={`b-${i}`} logo={logo} />)}
        </div>
      </div>
    </motion.div>
  );
};

// Phone mockup with interactive overlay
const PhoneMockup = () => {
  const [isHovered, setIsHovered] = useState(false);

  const openYouTube = () => {
    window.open(YOUTUBE_SHORTS_URL, '_blank', 'noopener,noreferrer');
  };

  const openSpotify = (e) => {
    e.stopPropagation();
    window.open(SPOTIFY_TRACK_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.div
      className="relative"
      animate={{ y: [0, -12, 0] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
    >
      {/* Screen glow */}
      <div 
        className="absolute -inset-4 rounded-[3rem] opacity-30 blur-2xl"
        style={{ background: 'radial-gradient(ellipse at center, rgba(25,164,251,0.4) 0%, transparent 70%)' }}
      />
      
      {/* Phone body */}
      <div 
        className="relative rounded-[2.5rem] p-[3px] bg-gradient-to-b from-[#555] via-[#333] to-[#444] shadow-[0_25px_60px_rgba(0,0,0,0.5),0_0_40px_rgba(25,164,251,0.1)]"
        style={{ transform: 'perspective(1200px) rotateY(-3deg) rotateX(1deg)' }}
      >
        {/* Inner bezel */}
        <div className="rounded-[2.35rem] bg-black p-[6px] relative overflow-hidden">
          {/* Subtle reflection on glass */}
          <div className="absolute inset-0 z-20 pointer-events-none rounded-[2.35rem]"
            style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, transparent 40%, transparent 60%, rgba(255,255,255,0.03) 100%)' }}
          />
          
          {/* Dynamic island */}
          <div className="absolute top-[10px] left-1/2 -translate-x-1/2 z-30 w-[90px] h-[26px] bg-black rounded-full" />
          
          {/* Screen area - 9:16 aspect ratio */}
          <div 
            className="relative rounded-[2rem] overflow-hidden bg-black cursor-pointer"
            style={{ aspectRatio: '9/16' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={openYouTube}
            data-testid="hero-phone-screen"
          >
            {/* YouTube iframe */}
            <iframe
              src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&mute=1&loop=1&playlist=${YOUTUBE_VIDEO_ID}&controls=0&showinfo=0&rel=0&playsinline=1&modestbranding=1&iv_load_policy=3&disablekb=1&fs=0&enablejsapi=1`}
              title="Cosmix Girlz - Soundmoo"
              className="absolute inset-0 w-full h-full border-0 pointer-events-none"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              loading="lazy"
              data-testid="hero-phone-video"
            />

            {/* Cosmix logo — top left (larger) */}
            <div className="absolute top-3 left-3 z-[15]">
              <img 
                src={COSMIX_LOGO} 
                alt="Cosmix" 
                className="h-9 md:h-12 drop-shadow-lg pointer-events-none"
              />
            </div>

            {/* OUT NOW badge — top right, links to Spotify */}
            <motion.button
              onClick={openSpotify}
              className="absolute top-3 right-3 z-[15] px-2.5 py-1 rounded-full bg-[#1DB954] text-white text-[10px] font-bold tracking-wide shadow-lg flex items-center gap-1 hover:bg-[#1ed760] transition-colors"
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.95 }}
              data-testid="phone-spotify-badge"
            >
              <svg className="w-3 h-3" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
              </svg>
              OUT NOW
            </motion.button>

            {/* Hover/tap overlay — blur + YouTube CTA */}
            <AnimatePresence>
              {isHovered && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.25 }}
                  className="absolute inset-0 z-[12] flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm"
                >
                  {/* YouTube play icon */}
                  <motion.div
                    initial={{ scale: 0.7, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.7, opacity: 0 }}
                    transition={{ duration: 0.3, delay: 0.05 }}
                    className="mb-3"
                  >
                    <div className="w-14 h-14 rounded-full bg-[#FF0000] flex items-center justify-center shadow-[0_0_30px_rgba(255,0,0,0.4)]">
                      <svg viewBox="0 0 24 24" fill="white" className="w-7 h-7 ml-0.5">
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </div>
                  </motion.div>
                  {/* Text */}
                  <motion.p
                    initial={{ y: 8, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 8, opacity: 0 }}
                    transition={{ duration: 0.3, delay: 0.1 }}
                    className="text-white font-semibold text-sm font-['Outfit'] tracking-wide"
                  >
                    Watch Cosmix Girlz - ACCESSORIZE
                  </motion.p>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Mobile: subtle always-visible play hint (no hover on touch) */}
            <div className="md:hidden absolute inset-0 z-[11] flex items-center justify-center pointer-events-none">
              <div className="w-10 h-10 rounded-full bg-[#FF0000]/70 flex items-center justify-center shadow-lg">
                <svg viewBox="0 0 24 24" fill="white" className="w-5 h-5 ml-0.5">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom shadow/reflection */}
      <div 
        className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-[70%] h-8 rounded-full opacity-20 blur-xl"
        style={{ background: 'radial-gradient(ellipse, rgba(25,164,251,0.5), transparent)' }}
      />
    </motion.div>
  );
};

export const HeroSection = () => {
  const containerRef = useRef(null);
  const [heroLogoOpacity, setHeroLogoOpacity] = useState(1);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, 200]);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

  // Big wordmark fades out on scroll
  useEffect(() => {
    const handleScroll = () => {
      const fade = Math.max(0, 1 - window.scrollY / 200);
      setHeroLogoOpacity(fade);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      const elementRect = element.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const offset = 80;
      window.scrollTo({
        top: absoluteElementTop - offset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section
      ref={containerRef}
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Spaceship characters — absolute inside hero, scrolls with section */}
      <HeroSpaceships />
      
      <motion.div style={{ y, opacity }} className="soundmoo-container relative z-10">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center pt-24 pb-6 lg:pt-16 lg:pb-8">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="text-left overflow-hidden"
          >
            {/* Big Soundmoo Wordmark — fades out on scroll, animated */}
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ 
                opacity: 1, 
                y: [0, -4, 0],
                scale: [1, 1.01, 1],
              }}
              transition={{ 
                opacity: { delay: 0.1, duration: 0.6 },
                y: { duration: 4, repeat: Infinity, ease: "easeInOut" },
                scale: { duration: 5, repeat: Infinity, ease: "easeInOut" },
              }}
              className="mb-5"
              style={{ opacity: heroLogoOpacity, filter: 'drop-shadow(0 0 20px rgba(255,255,255,0.15))' }}
              data-testid="hero-big-wordmark"
            >
              <img
                src={SOUNDMOO_LOGO}
                alt="Soundmoo"
                className="w-full max-w-[280px] sm:max-w-[400px] md:max-w-[500px] lg:max-w-[700px]"
              />
            </motion.div>

            {/* Headline */}
            <motion.h1
              data-testid="hero-headline"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6 font-['Outfit']"
            >
              Where <span className="text-[#19A4FB]">Characters</span> Become{' '}
              <span className="text-[#FBBF24]">Worlds.</span>
            </motion.h1>

            {/* Subheadline */}
            <motion.p
              data-testid="hero-subheadline"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
              className="text-base md:text-lg lg:text-xl text-white/90 leading-relaxed mb-5 md:mb-7 max-w-xl"
            >
              Soundmoo is a character IP studio developing original worlds and powering partner brands through character design, music identity, and licensing-ready creative.
            </motion.p>

            {/* CTAs */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.8 }}
              className="flex flex-col sm:flex-row gap-3"
            >
              <motion.button
                data-testid="hero-cta-primary"
                className="bg-white text-[#0A1A3F] px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2 text-sm md:text-base"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToContact}
              >
                Request Licensing Deck
                <ArrowRight className="w-5 h-5" />
              </motion.button>
              <motion.button
                data-testid="hero-cta-secondary"
                className="bg-white/10 border border-white/30 text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-medium backdrop-blur-sm hover:bg-white/20 transition-all flex items-center justify-center gap-2 text-sm md:text-base"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToContact}
              >
                Discuss a Partnership
              </motion.button>
            </motion.div>

            {/* Partner logos marquee */}
            <LogoMarquee />
          </motion.div>

          {/* Right Visual - Premium Phone Mockup with Cosmix Video */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, duration: 1, ease: 'easeOut' }}
            className="relative flex items-center justify-center mt-4 lg:mt-0"
          >
            {/* Soft ambient glow around phone */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-[240px] h-[400px] md:w-[320px] md:h-[500px] lg:w-[360px] lg:h-[560px] rounded-[3rem] opacity-40 blur-3xl" style={{ background: 'radial-gradient(ellipse, rgba(25,164,251,0.35) 0%, rgba(251,191,36,0.1) 50%, transparent 75%)' }} />
            </div>
            <div className="w-[200px] sm:w-[230px] md:w-[260px] lg:w-[300px] relative z-10">
              <PhoneMockup />
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-2"
        >
          <motion.div
            animate={{ height: ['20%', '80%', '20%'] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="w-1 bg-white/50 rounded-full"
          />
        </motion.div>
      </motion.div>
    </section>
  );
};
